import { z } from 'zod'

const ApiPerformanceSchema = z.object({
  count: z.number(),
  percentage: z.string()
})
const ApiOrdersPerformanceSchema = z.object({
  received: z.number(),
  rejected: ApiPerformanceSchema,
  accepted: ApiPerformanceSchema,
  cancelled: ApiPerformanceSchema,
  delivered: ApiPerformanceSchema,
  returned: ApiPerformanceSchema,
  inprogress: ApiPerformanceSchema,
  financially_delivered: ApiPerformanceSchema.optional()
})

const ApiOrdersPerformanceResponseSchema = z.object({
  orderPerformance: ApiOrdersPerformanceSchema
})

const ApiRatingDetails = z.object({
  rating: z.number(),
  comment: z.string(),
  username: z.string()
})

const ApiClientRatingDetails = ApiRatingDetails
const ApiDriverRatingDetails = ApiRatingDetails

const ApiReviewsPerformanceResponseSchema = z.object({
  avg_client_rating: z.number(),
  client_rating_details: z.array(ApiClientRatingDetails),
  driver_rating_details: z.array(ApiDriverRatingDetails),
  avg_driver_rating: z.number()
})

const ApiPreparationTimePerformanceSchema = z.object({
  message: z.string().optional(),
  preparation_time: z.number().nullable()
})

const ApiBestSellingDetails = z.object({
  count: z.number(),
  totalPrice: z.number(),
  item_id: z.string(),
  item_name: z.string(),
  avatar: z.string()
})

const ApiBestSellingResponseSchema = z.object({
  bestSellingPerformance: z.array(ApiBestSellingDetails)
})

const ApiRevenueSchema = z.array(
  z.object({
    date: z.string(),
    revenue: z.string()
  })
)

const ApiReimbursedCancelledSchema = z.object({
  count: z.number(),
  earnings: z.string()
})

const ApiRevenuePayoutFieldsSchema = {
  returned_earnings: z.string().optional(),
  tax_stamp_deductions: z.string().optional(),
  tax_stamp_per_cycle: z.string().optional(),
  cycles_in_window: z.number().optional(),
  in_progress_cycle: z.boolean().optional(),
  reimbursed_cancelled: ApiReimbursedCancelledSchema.optional()
}

const ApiRevenuePerformanceData = z.object({
  currency: z.string(),
  netEarning: z.string(),
  grossEarning: z.string(),
  comission: z.string(),
  revenue: ApiRevenueSchema,
  area: z.string().optional(),
  ...ApiRevenuePayoutFieldsSchema
})

const ApiBranchRevenuePerformanceData = z.object({
  currency: z.string(),
  netEarning: z.string(),
  grossEarning: z.string(),
  comission: z.string(),
  revenue: ApiRevenueSchema,
  ...ApiRevenuePayoutFieldsSchema
})

const ApiRevenueResponseSchema = z.object({
  data: ApiRevenuePerformanceData,
  status: z.string()
})

const ApiExportOrderItem = z.object({
  'Store ID': z.string(),
  'Store Name': z.string(),
  'Order ID': z.string(),
  'Order food items': z.string(),
  'Item Total': z.number(),
  'Commission amount': z.number(),
  'Order created At': z.string(),
  'Order Delivered At': z.string(),
  'Pickup Status': z.string(),
  'Order Final status': z.string()
})

const ApiExportOrdersPerformanceResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  data: z.array(ApiExportOrderItem)
})

export type IRevenuePerformanceData = z.infer<typeof ApiRevenuePerformanceData>
export type IExportOrdersPerformanceResponse = z.infer<typeof ApiExportOrdersPerformanceResponseSchema>

export {
  ApiBestSellingDetails,
  ApiBestSellingResponseSchema,
  ApiExportOrdersPerformanceResponseSchema,
  ApiOrdersPerformanceResponseSchema,
  ApiOrdersPerformanceSchema,
  ApiPerformanceSchema,
  ApiPreparationTimePerformanceSchema,
  ApiRatingDetails,
  ApiRevenuePerformanceData,
  ApiRevenueResponseSchema,
  ApiReviewsPerformanceResponseSchema
}
